import i from "./index.ce.vue.js";
import { defineAndRegisterElement as e } from "../../utils/register-element.js";
const r = e(i);
export {
  r as initAiUrgentDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-urgent-dialog/index.js
// module id = 1214
// module chunks = 67